/**
 * Security Configuration for react-js
 * Iframe and token communication security settings
 */

// Allowed iframe origins for postMessage
export const ALLOWED_IFRAME_ORIGINS = [
  // Production
  process.env.REACT_APP_LOVABLE_ORIGIN || 'https://gs-insiders.lovable.app',

  // Development - Only in development mode
  ...(process.env.NODE_ENV === 'development'
    ? [
        'http://localhost:5173',
        'http://localhost:5174',
        'http://localhost:8080',
        'http://localhost:3003',
      ]
    : []),
];

/**
 * Get the target origin for postMessage
 * Returns specific origin, never wildcard
 */
export const getTargetOrigin = () =>
  // Always use specific origin from environment or default
  process.env.REACT_APP_LOVABLE_ORIGIN || 'https://gs-insiders.lovable.app';

/**
 * Validate if origin is allowed to receive messages
 */
export const isIframeOriginAllowed = (origin) =>
  ALLOWED_IFRAME_ORIGINS.includes(origin);
